import React from 'react'
import Grid from '@mui/material/Grid'
import { isEmpty } from 'libraries/lodash'
import { getDescendants } from 'services/DocumentService'
import { DOCUMENTS_FAVOURITING } from 'constants/feature-flags'
import Tile from './Tile'
import url from 'libraries/front-end-core/core/url'
import { DOCUMENTS_CONTENT } from 'constants/controllers'
import { AOL_CORPORATE, AOL_DISPLAY_NAMES } from 'constants/aol/aol'

const DocumentsTiledMenu = ({
  tiledMenu,
  dataHelpItem,
  ignoreNodes = false,
  documents,
  documentFavourites,
  ...props
}) => {
  const { topLevelSections, nodes } = tiledMenu

  if (isEmpty(topLevelSections) || (!ignoreNodes && isEmpty(nodes))) {
    return null
  }
  const safeKeyword = props.keyword.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(safeKeyword, 'i')

  const renderedTiles = topLevelSections.reduce((acc, tile, index) => {
    if (!tile.active) return acc
    if (props.showFavouritesOnly) {
      const tileIsFavourite = (props.favourites || []).includes(tile.id)
      const tileHasFavouriteDocument = DOCUMENTS_FAVOURITING && (documentFavourites || []).some(docId =>
        documents.some(doc => doc.id === docId && tile.descendants.includes(doc.parentId))
      )
      if (!tileIsFavourite && !tileHasFavouriteDocument) return acc
    }
    const descendants = safeKeyword.length > 0
      ? getDescendants(nodes, tile.id, props.flavour)
      : []

    const matchingDescendants = descendants.filter(obj => regex.test(obj.title))
    const filteredDocuments = safeKeyword.length > 0
      ? documents.reduce((acc, curr) => {
        if (!tile.descendants.some(id => id === curr.parentId)) {
          return acc
        }

        if (regex.test(curr.title)) {
          return [
            ...acc,
            {
              title: curr.title,
              sectionId: curr.parentId,
              path: url(DOCUMENTS_CONTENT, {
                aol: AOL_CORPORATE,
                sectionId: tile.id,
                focusedId: curr.id
              })
            }
          ]
        }
        return acc
      }, [])
      : []

    const allMatches = [...filteredDocuments, ...matchingDescendants]
    if (safeKeyword.length > 0 && allMatches.length === 0) return acc

    return [
      ...acc,
      (
        <Grid key={index} item xs={12} sm={4} md={3} lg={2}>
          <Tile
            {...{
              nodes,
              ...tile,
              ...props,
              keyword: props.keyword,
              matchingDescendants: allMatches,
              aol: tile.areaOfLaw
            }}
          />
        </Grid>
      )
    ]
  }, [])

  return (
    <nav>
      {topLevelSections.length > 0 && renderedTiles.length > 0 && (
        <div className='tile-container' data-help-item={dataHelpItem} data-help-position='middle'>
          <Grid container spacing={2}>
            {renderedTiles}
          </Grid>
        </div>
      )}
      {renderedTiles.length === 0 && (
        <p className='f3 tc i'>
          {safeKeyword.length > 0 ? `No results for keyword "${props.keyword}"` : 'No favourites selected'} in {AOL_DISPLAY_NAMES[props.aols[0]]}
        </p>
      )}
    </nav>
  )
}

export default DocumentsTiledMenu
